import React from 'react'
import { ParagraphSM } from '@/atoms/Text'

interface AddressProps {
  loading?: boolean
  address?: {
    line1?: string
    line2?: string
    city?: string
    state?: string
    zip?: number | string
    country?: string
  }
}

const AddressText: React.FC<AddressProps> = ({
  loading = false,
  address = { line1: '---', line2: '', city: '---', state: '---', zip: '---', country: '---' },
}) => {
  const isValidAddress = !!(
    address?.line1 ||
    address?.line2 ||
    address?.city ||
    address?.state ||
    address?.zip ||
    address?.country
  )

  if (!isValidAddress) return <ParagraphSM color="error-500">Address is required</ParagraphSM>

  return (
    <div className="flex flex-col justify-center items-start flex-grow-1">
      {loading ? (
        <>
          <div className="animate-pulse bg-core-gray-500 w-1/2 h-[18.66667px] rounded-lg" />
          <div className="animate-pulse bg-core-gray-500 w-1/2 h-[18.66667px] rounded-lg my-2" />
          <div className="animate-pulse bg-core-gray-500 w-1/2 h-[18.66667px] rounded-lg" />
        </>
      ) : (
        <>
          <ParagraphSM>{address?.line1}</ParagraphSM>
          <ParagraphSM>{address?.line2}</ParagraphSM>
          <ParagraphSM>
            {address?.city} {address?.state?.toUpperCase()}
            {address?.state && ','} {address?.zip} {address?.country}
          </ParagraphSM>
        </>
      )}
    </div>
  )
}

export { AddressText }
